//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    subline: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    itemsBreadcrumb: {
      type: Array,
      default() {},
    },
    image: {
      type: Object,
      default() {},
    },
    buttons: {
      type: Array,
      default() {},
    },
    sectionType: {
      type: String,
      default: 'SIMPLE',
    },
  },
  computed: {
    breadcrumb() {
      const breadcrumbSimple = !this.itemsBreadcrumb? [{ title: this.title, slug: ''}] : null
      return breadcrumbSimple;
    },
  },
  data() {
    return {
      currentIndex: this.dataIndex,
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-connect-03.svg?data`),
          width: 130,
          height: 126,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-hear-03.svg?data`),
          width: 275,
          height: 262,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
      ],
    }
  },
}
